import { Navigate, Route, Routes } from "react-router";
import { ClientHubPage } from "./clients/ClientHubPage";
import { ClientsLayout } from "./clients/ClientsLayout";
import { ClientsPage } from "./clients/ClientsPage";
import { LegalPage } from "./clients/LegalPage";
import { V2Layout, v2StageRoutes } from "./layout/Layout";
import { PageNotFound } from "./layout/PageNotFound";

/**
 * The attorney workflow's route table, as a descendant `<Routes>` under the
 * root splat in `App.tsx`. Its own table rather than spread into `App.tsx`, so
 * the stage routes sit beside the layout that hosts them.
 */
export function V2Routes() {
  return (
    <Routes>
      {/* Above any draft: the attorney's clients, and each client's drafts. Their
          own layout, since no draft is open and so no rail has anything to show. */}
      <Route path="clients" element={<ClientsLayout />}>
        <Route index element={<ClientsPage />} />
        <Route path="unassigned" element={<ClientHubPage unassigned />} />
        <Route path=":clientId" element={<ClientHubPage />} />
      </Route>
      <Route path="legal" element={<ClientsLayout />}>
        <Route index element={<LegalPage />} />
      </Route>
      <Route path="/" element={<V2Layout />}>
        {v2StageRoutes()}
      </Route>
      {/* v1's old prefix: its pages are gone, so its addresses open the front page. */}
      <Route path="legacy/*" element={<Navigate to="/" replace />} />
      {/* This table answers on every address the static entries in `App.tsx`
          leave to it, including ones nothing here names: a stale bookmark or a
          typed path. Without this the shell renders against no route at all and
          the page comes up blank, with nothing on it to leave by. */}
      <Route element={<ClientsLayout />}>
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}
